// extracted by mini-css-extract-plugin
export default {"wrapperCamera":"styles_wrapperCamera__8kHSw","buttonShutter":"styles_buttonShutter__T7Z1S"};